<section id="secao-fases">
  <div class="container">
    <div class="row justify-content-center r-titulo">
      <svg
        class="pp-small-triangle"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        fill="#ffffff"
        width="100%"
        height="20"
        viewBox="0 0 0.156661 0.1"
      >
        <polygon
          points="0.156661,3.93701e-006 0.156661,0.000429134 0.117665,0.05 0.0783307,0.0999961 0.0389961,0.05 -0,0.000429134 -0,3.93701e-006 0.0783307,3.93701e-006 "
        ></polygon>
      </svg>
      <h1 class="titulo">Fases</h1>
      <div class="row divisor">
        <hr class="hr" />
      </div>
    </div>
    <div class="row r-texto">
      <h1>Ideação</h1>
      <p>
        A Fundação Educere é um dos parceiro do Empreendemove, projeto com
        duração aproximada de 4 meses, que tem por objetivo ajudar o
        empreendedor a desenvolver ideias e soluções para problemas específicos.
      </p>

      <h5>O que oferecemos nesta fase?</h5>
      <p>
        Durante 4 meses, o Empreendemove oferece 3 oficinas, 2 meses de
        assessoria e mentoria para o desenvolvimento da sua ideia. <br />No
        final, os projetos selecionados são submetidos à uma banca de avaliação
        para pré-incubação.
      </p>

      <!-- <h1>Pré-incubação</h1>
      <p>
        Da ideia ao protótipo. Na pré-incubação, ajudamos o empreendedor a
        desenvolver a sua ideia e o modelo de negócio, até a definição do
        produto mínimo viável (MVP) ou protótipo do produto.
      </p> -->
      <h5>O que oferecemos nesta fase?</h5>
      <p>
        Espaço coworking, mentorias, qualificação do empreendedor e acesso ao
        network Educere para o desenvolvimento do projeto.
      </p>

      <h1>Incubação</h1>
      <p>
        Na incubação, ajudamos o empreendedor a desenvolver o seu negócio com
        foco no mercado.
      </p>
      <h5>O que oferecemos nesta fase?</h5>
      <p>
        Espaço individual, mentorias, qualificação e acompanhamento do
        empreendedor nos eixos tecnologia, mercado, capital, gestão e
        empreendedor, além do apoio do network Educere para o desenvolvimento da
        empresa.
      </p>
      <h1>Aceleração</h1>
      <p>A Fundação Educere ajuda você a alavancar o seu negócio no mercado.</p>
      <h5>O que oferecemos nesta fase?</h5>
      <p>
        A Fundação Educere possui um grupo de investidores anjos que unem o
        capital com a experiência profissional para ajudar по desenvolvimento do
        seu negócio.
      </p>
      <h1>Graduação</h1>
      <p>
        Um dos diferenciais da Fundação Educere é sua network altamente
        colaborativa.
      </p>
      <h5>O que oferecemos nesta fase?</h5>
      <p>
        Os empresários das empresas graduadas participam da gestão da
        instituição, compartilham boas práticas e resultados alcançados pelas
        empresas e participam do monitoramento dos empreendimentos pré-incubados
        e incubados por meio de mentorias.
      </p>
    </div>
    <div class="row r-azul-escuro"></div>
  </div>
</section>
